// extracted by mini-css-extract-plugin
export var phone = "_4j-0";
export var phoneDragging = "_4j-1";